module.exports = __webpack_public_path__ + "static/media/inventory.4202e9cd.svg";